import { MirrorscapeImage } from "../Data/Response";
import styles from './GamePlayerView.module.scss';

interface PlayerViewArgs {
    avatar: MirrorscapeImage;
    username: string;
    isOnline: boolean;
    isYou: boolean;
    id: string
    crewName?: string;
    reputation: number;
    colorHex: string;
    // crewId?: string;
}

const GamePlayerView: React.FC<PlayerViewArgs> = args => {


    return <div className={styles.gamePlayerView}>
        <div className={`${styles.avatar} ${args.isOnline ? styles.isOnline : ""}`}>
            <img src={args.avatar.smallUrl} />
        </div>
        <div className={styles.info}>
            <h2
                style={{ color: args.colorHex }}
                className={styles.crewName}
            >{args.crewName ?? "No Crew Selected"}</h2>
            <h2
                style={{ color: args.colorHex }}
                className={styles.username}
            >{args.isYou ? "YOU: " : ""}{args.username}</h2>
            <h3 className={styles.playerId}>{args.id}</h3>
            <h3 className={styles.reputation}>Reputation: {args.reputation}</h3>
            {/* <h3 className={styles.crewId}>{args.crewId}</h3> */}
        </div>
    </div>
}

export default GamePlayerView;